import { forwardRef, memo, ReactNode } from 'react';
import classes from 'classnames';
import CloseIcon from 'assets/icons/close-small.svg?react';
import styles from './Card.module.scss';

export type Props = {
  children: ReactNode;
  className?: string;
  dataTest?: string;
  onClick?: () => void;
  onClose?: () => void;
};

const Card = forwardRef<HTMLDivElement, Props>(function Card(
  { children, className, dataTest = 'card', onClick, onClose },
  ref,
) {
  return (
    <div
      onClick={onClick}
      ref={ref}
      data-test={dataTest}
      data-testid={dataTest}
      className={classes(styles.card, className)}
    >
      {onClose && (
        <CloseIcon
          className={styles.close}
          onClick={onClose}
          data-test="card-close-icon"
        />
      )}
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default memo(Card);
